import {
  HOST,
  DEBUG_MODE,
  CONTACT_EMAIL,
  FLAG_ICON_PERU,
  FLAG_ICON_CHILE,
  FLAG_ICON_INDIA,
  FLAG_ICON_SPAIN,
  FLAG_ICON_CANADA,
  FLAG_ICON_MEXICO,
  FLAG_ICON_FRANCE,
  CONTACT_EMAIL_ES,
  CONTACT_EMAIL_FR,
  FLAG_ICON_BELGIUM,
  FLAG_ICON_IRELAND,
  FLAG_ICON_URUGUAY,
  FLAG_ICON_COLOMBIA,
  FLAG_ICON_HONDURAS,
  FLAG_ICON_VENEZUELA,
  FLAG_ICON_ARGENTINA,
  FLAG_ICON_AUSTRALIA,
  ARWEAVE_GATEWAY_MAIN,
  FLAG_ICON_COSTA_RICA,
  FLAG_ICON_NORTH_KOREA,
  FLAG_ICON_SOUTH_KOREA,
  FLAG_ICON_NEW_ZEALAND,
  FLAG_ICON_SWITZERLAND,
  FLAG_ICON_SOUTH_AFRICA,
  FLAG_ICON_UNITED_STATES,
  FLAG_ICON_UNITED_KINGDOM,
  ISO_4217_CURRENCY_CODE_EURO,
  DEFAULT_SUBSCRIPTION_PRICE_USD,
  DEFAULT_SUBSCRIPTION_PRICE_CAD,
  DEFAULT_SUBSCRIPTION_PRICE_EURO,
  DEFAULT_SUBSCRIPTION_PRICE_POUND,
  ISO_4217_CURRENCY_CODE_US_DOLLAR,
  ISO_4217_CURRENCY_CODE_BRITISH_POUND,
  ISO_4217_CURRENCY_CODE_CANADA_DOLLAR,
} from './config'
import {
  isNullOrEmptyString,
  isNotNullOrUndefined,
  isNotNullOrEmptyString,
  toTrimmedStringLowerCase,
  toTrimmedStringUpperCase,
  CANADA_ISO_3166_ALPHA_2_CODE,
  BRITAIN_ISO_3166_ALPHA_2_CODE,
  getSubscriptionPriceValidUntil,
  BRITAIN_ISO_3166_ALPHA_2_CODE_ALT,
  SOUTH_KOREA_ISO_3166_ALPHA_2_CODE,
  EURO_CURRENCY_ISO_3166_ALPHA_2_COUNTRY_CODES,
} from './misc'

// #region PRODUCT NAME
export const PRODUCT_NAME: string = 'Practical Stream'
export const PRODUCT_NAME_LITERAL_UNBROKEN: string = 'Practical&nbsp;Stream'
export const BRAND_NAME: string = PRODUCT_NAME
// #endregion

// #region COMPETITORS
export const SOUNDTRACK_YOUR_BRAND_PRODUCT_NAME: string =
  'Soundtrack Your Brand'
export const MOOD_MEDIA_PRODUCT_NAME: string = 'Mood Media'
export const CLOUD_COVER_PRODUCT_NAME: string = 'Cloudcover Music'
export const ROCKBOT_PRODUCT_NAME: string = 'Rockbot'
export const JUKEBOXY_PRODUCT_NAME: string = 'Jukeboxy'
export const PANDORA_BRAND_NAME: string = 'Pandora'
// #endregion

// #region LANGUAGE CODES
export const LANGUAGE_CODE_SPANISH: string = 'es'
export const LANGUAGE_CODE_ENGLISH: string = 'en'
export const LANGUAGE_CODE_FRENCH: string = 'fr'
export const LANGUAGE_CODE_KOREAN: string = 'ko'
// #endregion

export const LANGUAGE_LOCALE_CODE_US_ENGLISH: string =
  LANGUAGE_CODE_ENGLISH + '-US'
export const LANGUAGE_LOCALE_CODE_UK_ENGLISH: string =
  LANGUAGE_CODE_ENGLISH + '-UK'
export const LANGUAGE_LOCALE_CODE_UK_ENGLISH_ALT_1: string =
  LANGUAGE_CODE_ENGLISH + '-GB'
export const LANGUAGE_LOCALE_CODE_UK_ENGLISH_ALT_2: string =
  LANGUAGE_CODE_ENGLISH + '-GB-oxendict'
export const LANGUAGE_LOCALE_CODE_CANADA_ENGLISH: string =
  LANGUAGE_CODE_ENGLISH + '-CA'
export const LANGUAGE_LOCALE_CODE_AUSTRALIA_ENGLISH: string =
  LANGUAGE_CODE_ENGLISH + '-AU'
export const LANGUAGE_LOCALE_CODE_ENGLISH_SOUTH_AFRICA: string =
  LANGUAGE_CODE_ENGLISH + '-ZA'
export const LANGUAGE_LOCALE_CODE_ENGLISH_IRELAND: string =
  LANGUAGE_CODE_ENGLISH + '-IE'
export const LANGUAGE_LOCALE_CODE_ENGLISH_INDIA: string =
  LANGUAGE_CODE_ENGLISH + '-IN'
export const LANGUAGE_LOCALE_CODE_ENGLISH_NEW_ZEALAND: string =
  LANGUAGE_CODE_ENGLISH + '-NZ'
export const LANGUAGE_LOCALE_CODE_SPAIN_SPANISH: string =
  LANGUAGE_CODE_SPANISH + '-ES'
export const LANGUAGE_LOCALE_CODE_VENEZUELA_SPANISH: string =
  LANGUAGE_CODE_SPANISH + '-VE'
export const LANGUAGE_LOCALE_CODE_ARGENTINA_SPANISH: string =
  LANGUAGE_CODE_SPANISH + '-AR'
export const LANGUAGE_LOCALE_CODE_CHILE_SPANISH: string =
  LANGUAGE_CODE_SPANISH + '-CL'
export const LANGUAGE_LOCALE_CODE_COLOMBIA_SPANISH: string =
  LANGUAGE_CODE_SPANISH + '-CO'
export const LANGUAGE_LOCALE_CODE_COSTA_RICA_SPANISH: string =
  LANGUAGE_CODE_SPANISH + '-CR'
export const LANGUAGE_LOCALE_CODE_HONDURAS_SPANISH: string =
  LANGUAGE_CODE_SPANISH + '-HN'
export const LANGUAGE_LOCALE_CODE_MEXICO_SPANISH: string =
  LANGUAGE_CODE_SPANISH + '-MX'
export const LANGUAGE_LOCALE_CODE_PERU_SPANISH: string =
  LANGUAGE_CODE_SPANISH + '-PE'
export const LANGUAGE_LOCALE_CODE_URUGUAY_SPANISH: string =
  LANGUAGE_CODE_SPANISH + '-UY'

export const LANGUAGE_LOCALE_CODE_FRANCE_FRENCH: string =
  LANGUAGE_CODE_FRENCH + '-FR'
export const LANGUAGE_LOCALE_CODE_CANADA_FRENCH: string =
  LANGUAGE_CODE_FRENCH + '-FR'
export const LANGUAGE_LOCALE_CODE_BELGIUM_FRENCH: string =
  LANGUAGE_CODE_FRENCH + '-BE'
export const LANGUAGE_LOCALE_CODE_SWITZERLAND_FRENCH: string =
  LANGUAGE_CODE_FRENCH + '-CH'

export const LANGUAGE_LOCALE_CODE_NORTH_KOREA_KOREAN: string =
  LANGUAGE_CODE_KOREAN + '-KP'
export const LANGUAGE_LOCALE_CODE_SOUTH_KOREA_KOREAN: string =
  LANGUAGE_CODE_KOREAN + '-KR'

export function isSpanish(selectedLanguage: any) {
  let ret: boolean = false
  try {
    ret =
      toTrimmedStringLowerCase(selectedLanguage).indexOf(
        LANGUAGE_CODE_SPANISH
      ) == 0
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function isFrench(selectedLanguage: any) {
  let ret: boolean = false
  try {
    ret =
      toTrimmedStringLowerCase(selectedLanguage).indexOf(
        LANGUAGE_CODE_FRENCH
      ) == 0
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function isKorean(selectedLanguage: any) {
  let ret: boolean = false
  try {
    ret =
      toTrimmedStringLowerCase(selectedLanguage).indexOf(
        LANGUAGE_CODE_KOREAN
      ) == 0
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function isEnglish(selectedLanguage: any) {
  let ret: boolean = false
  try {
    ret =
      toTrimmedStringLowerCase(selectedLanguage).indexOf(
        LANGUAGE_CODE_ENGLISH
      ) == 0 || isNullOrEmptyString(selectedLanguage)
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function translate(
  englishText: any,
  spanishText: any,
  frenchText: any,
  koreanText: any,
  overrideLanguage: any
) {
  let ret: string = englishText
  try {
    ret =
      isNotNullOrUndefined(overrideLanguage) &&
      toTrimmedStringLowerCase(overrideLanguage).indexOf(
        LANGUAGE_CODE_ENGLISH
      ) == 0
        ? englishText
        : isNotNullOrUndefined(overrideLanguage) &&
          toTrimmedStringLowerCase(overrideLanguage).indexOf(
            LANGUAGE_CODE_SPANISH
          ) == 0
        ? spanishText
        : isNotNullOrUndefined(overrideLanguage) &&
          toTrimmedStringLowerCase(overrideLanguage).indexOf(
            LANGUAGE_CODE_FRENCH
          ) == 0
        ? frenchText
        : isNotNullOrUndefined(overrideLanguage) &&
          toTrimmedStringLowerCase(overrideLanguage).indexOf(
            LANGUAGE_CODE_KOREAN
          ) == 0
        ? koreanText
        : toTrimmedStringLowerCase(navigator?.language).indexOf(
            LANGUAGE_CODE_SPANISH
          ) == 0
        ? spanishText
        : toTrimmedStringLowerCase(navigator?.language).indexOf(
            LANGUAGE_CODE_FRENCH
          ) == 0
        ? frenchText
        : toTrimmedStringLowerCase(navigator?.language).indexOf(
            LANGUAGE_CODE_KOREAN
          ) == 0
        ? koreanText
        : englishText
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return isNotNullOrEmptyString(ret) ? ret : englishText
}

export function getNavigatorLanguage() {
  let ret: string = LANGUAGE_LOCALE_CODE_US_ENGLISH
  try {
    ret = isNotNullOrEmptyString(navigator?.language)
      ? navigator?.language
      : LANGUAGE_LOCALE_CODE_US_ENGLISH
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function isValidLanguage(s: any) {
  let ret: boolean = false
  try {
    ret =
      isNotNullOrEmptyString(s) &&
      (s.indexOf(LANGUAGE_CODE_SPANISH) == 0 ||
        s.indexOf(LANGUAGE_CODE_ENGLISH) == 0 ||
        s.indexOf(LANGUAGE_CODE_FRENCH) == 0 ||
        s.indexOf(LANGUAGE_CODE_KOREAN) == 0)
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function isNonAsciiLanguage(selLanguage: any) {
  let retVal: boolean = false
  try {
    retVal = selLanguage == LANGUAGE_CODE_KOREAN
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return retVal
}

export function getFlagIcon(selLanguage: any, navLanguage: any) {
  let ret: string = FLAG_ICON_UNITED_STATES
  let defaultIcon =
    navLanguage == LANGUAGE_CODE_ENGLISH
      ? FLAG_ICON_UNITED_STATES
      : navLanguage == LANGUAGE_CODE_FRENCH
      ? FLAG_ICON_FRANCE
      : navLanguage == LANGUAGE_CODE_SPANISH
      ? FLAG_ICON_SPAIN
      : navLanguage == LANGUAGE_CODE_KOREAN
      ? FLAG_ICON_SOUTH_KOREA
      : FLAG_ICON_UNITED_STATES
  try {
    ret =
      selLanguage == LANGUAGE_CODE_ENGLISH &&
      navLanguage == LANGUAGE_LOCALE_CODE_US_ENGLISH
        ? FLAG_ICON_UNITED_STATES
        : selLanguage == LANGUAGE_CODE_ENGLISH &&
          (navLanguage == LANGUAGE_LOCALE_CODE_UK_ENGLISH ||
            navLanguage == LANGUAGE_LOCALE_CODE_UK_ENGLISH_ALT_1 ||
            navLanguage == LANGUAGE_LOCALE_CODE_UK_ENGLISH_ALT_2)
        ? FLAG_ICON_UNITED_KINGDOM
        : selLanguage == LANGUAGE_CODE_ENGLISH &&
          navLanguage == LANGUAGE_LOCALE_CODE_CANADA_ENGLISH
        ? FLAG_ICON_CANADA
        : selLanguage == LANGUAGE_CODE_ENGLISH &&
          navLanguage == LANGUAGE_LOCALE_CODE_ENGLISH_IRELAND
        ? FLAG_ICON_IRELAND
        : selLanguage == LANGUAGE_CODE_ENGLISH &&
          navLanguage == LANGUAGE_LOCALE_CODE_ENGLISH_INDIA
        ? FLAG_ICON_INDIA
        : selLanguage == LANGUAGE_CODE_ENGLISH &&
          navLanguage == LANGUAGE_LOCALE_CODE_AUSTRALIA_ENGLISH
        ? FLAG_ICON_AUSTRALIA
        : selLanguage == LANGUAGE_CODE_ENGLISH &&
          navLanguage == LANGUAGE_LOCALE_CODE_ENGLISH_NEW_ZEALAND
        ? FLAG_ICON_NEW_ZEALAND
        : selLanguage == LANGUAGE_CODE_ENGLISH &&
          navLanguage == LANGUAGE_LOCALE_CODE_ENGLISH_SOUTH_AFRICA
        ? FLAG_ICON_SOUTH_AFRICA
        : selLanguage == LANGUAGE_CODE_SPANISH &&
          navLanguage == LANGUAGE_LOCALE_CODE_VENEZUELA_SPANISH
        ? FLAG_ICON_VENEZUELA
        : selLanguage == LANGUAGE_CODE_SPANISH &&
          navLanguage == LANGUAGE_LOCALE_CODE_ARGENTINA_SPANISH
        ? FLAG_ICON_ARGENTINA
        : selLanguage == LANGUAGE_CODE_SPANISH &&
          navLanguage == LANGUAGE_LOCALE_CODE_CHILE_SPANISH
        ? FLAG_ICON_CHILE
        : selLanguage == LANGUAGE_CODE_SPANISH &&
          navLanguage == LANGUAGE_LOCALE_CODE_COLOMBIA_SPANISH
        ? FLAG_ICON_COLOMBIA
        : selLanguage == LANGUAGE_CODE_SPANISH &&
          navLanguage == LANGUAGE_LOCALE_CODE_COSTA_RICA_SPANISH
        ? FLAG_ICON_COSTA_RICA
        : selLanguage == LANGUAGE_CODE_SPANISH &&
          navLanguage == LANGUAGE_LOCALE_CODE_HONDURAS_SPANISH
        ? FLAG_ICON_HONDURAS
        : selLanguage == LANGUAGE_CODE_SPANISH &&
          navLanguage == LANGUAGE_LOCALE_CODE_MEXICO_SPANISH
        ? FLAG_ICON_MEXICO
        : selLanguage == LANGUAGE_CODE_SPANISH &&
          navLanguage == LANGUAGE_LOCALE_CODE_PERU_SPANISH
        ? FLAG_ICON_PERU
        : selLanguage == LANGUAGE_CODE_SPANISH &&
          navLanguage == LANGUAGE_LOCALE_CODE_URUGUAY_SPANISH
        ? FLAG_ICON_URUGUAY
        : selLanguage == LANGUAGE_CODE_FRENCH &&
          navLanguage == LANGUAGE_LOCALE_CODE_CANADA_FRENCH
        ? FLAG_ICON_CANADA
        : selLanguage == LANGUAGE_CODE_KOREAN &&
          navLanguage == LANGUAGE_LOCALE_CODE_NORTH_KOREA_KOREAN
        ? FLAG_ICON_NORTH_KOREA
        : selLanguage == LANGUAGE_CODE_KOREAN &&
          navLanguage == LANGUAGE_LOCALE_CODE_SOUTH_KOREA_KOREAN
        ? FLAG_ICON_SOUTH_KOREA
        : selLanguage == LANGUAGE_CODE_SPANISH
        ? FLAG_ICON_SPAIN
        : selLanguage == LANGUAGE_CODE_FRENCH
        ? FLAG_ICON_FRANCE
        : selLanguage == LANGUAGE_CODE_KOREAN
        ? FLAG_ICON_SOUTH_KOREA
        : selLanguage == LANGUAGE_CODE_ENGLISH
        ? FLAG_ICON_UNITED_STATES
        : defaultIcon
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function getFlagIconEnglish(navLanguage: any) {
  let ret: string = FLAG_ICON_UNITED_STATES
  try {
    ret =
      navLanguage == LANGUAGE_LOCALE_CODE_UK_ENGLISH ||
      navLanguage == LANGUAGE_LOCALE_CODE_UK_ENGLISH_ALT_1 ||
      navLanguage == LANGUAGE_LOCALE_CODE_UK_ENGLISH_ALT_2
        ? FLAG_ICON_UNITED_KINGDOM
        : navLanguage == LANGUAGE_LOCALE_CODE_CANADA_ENGLISH
        ? FLAG_ICON_CANADA
        : navLanguage == LANGUAGE_LOCALE_CODE_ENGLISH_SOUTH_AFRICA
        ? FLAG_ICON_SOUTH_AFRICA
        : navLanguage == LANGUAGE_LOCALE_CODE_AUSTRALIA_ENGLISH
        ? FLAG_ICON_AUSTRALIA
        : navLanguage == LANGUAGE_LOCALE_CODE_ENGLISH_IRELAND
        ? FLAG_ICON_IRELAND
        : navLanguage == LANGUAGE_LOCALE_CODE_ENGLISH_NEW_ZEALAND
        ? FLAG_ICON_NEW_ZEALAND
        : navLanguage == LANGUAGE_LOCALE_CODE_ENGLISH_INDIA
        ? FLAG_ICON_INDIA
        : FLAG_ICON_UNITED_STATES
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function getFlagIconSpanish(navLanguage: any) {
  let ret: string = FLAG_ICON_UNITED_STATES
  try {
    ret =
      navLanguage == LANGUAGE_LOCALE_CODE_ARGENTINA_SPANISH
        ? FLAG_ICON_ARGENTINA
        : navLanguage == LANGUAGE_LOCALE_CODE_CHILE_SPANISH
        ? FLAG_ICON_CHILE
        : navLanguage == LANGUAGE_LOCALE_CODE_COLOMBIA_SPANISH
        ? FLAG_ICON_COLOMBIA
        : navLanguage == LANGUAGE_LOCALE_CODE_COSTA_RICA_SPANISH
        ? FLAG_ICON_COSTA_RICA
        : navLanguage == LANGUAGE_LOCALE_CODE_HONDURAS_SPANISH
        ? FLAG_ICON_HONDURAS
        : navLanguage == LANGUAGE_LOCALE_CODE_MEXICO_SPANISH
        ? FLAG_ICON_MEXICO
        : navLanguage == LANGUAGE_LOCALE_CODE_PERU_SPANISH
        ? FLAG_ICON_PERU
        : navLanguage == LANGUAGE_LOCALE_CODE_URUGUAY_SPANISH
        ? FLAG_ICON_URUGUAY
        : navLanguage == LANGUAGE_LOCALE_CODE_VENEZUELA_SPANISH
        ? FLAG_ICON_VENEZUELA
        : FLAG_ICON_SPAIN
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function getFlagIconFrench(navLanguage: any) {
  let ret: string = FLAG_ICON_UNITED_STATES
  try {
    ret =
      navLanguage == LANGUAGE_LOCALE_CODE_CANADA_FRENCH
        ? FLAG_ICON_CANADA
        : navLanguage == LANGUAGE_LOCALE_CODE_FRANCE_FRENCH
        ? FLAG_ICON_FRANCE
        : navLanguage == LANGUAGE_LOCALE_CODE_BELGIUM_FRENCH
        ? FLAG_ICON_BELGIUM
        : navLanguage == LANGUAGE_LOCALE_CODE_SWITZERLAND_FRENCH
        ? FLAG_ICON_SWITZERLAND
        : FLAG_ICON_FRANCE
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function getFlagIconKorean(navLanguage: any) {
  let ret: string = FLAG_ICON_UNITED_STATES
  try {
    ret =
      navLanguage == LANGUAGE_LOCALE_CODE_SOUTH_KOREA_KOREAN
        ? FLAG_ICON_SOUTH_KOREA
        : navLanguage == LANGUAGE_LOCALE_CODE_NORTH_KOREA_KOREAN
        ? FLAG_ICON_NORTH_KOREA
        : FLAG_ICON_SOUTH_KOREA
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

// #region MHOME PAGE LOGO
export const HOME_PS_LOGO: string =
  ARWEAVE_GATEWAY_MAIN + 'AkCjLipY8aabtWJNjpQ8OQd0VBlMVMJgzltJoj8QFBE'
// #region MHOME PAGE LOGO
export const JSON_LD_BRAND_LOGO: string =
  ARWEAVE_GATEWAY_MAIN + 'AkCjLipY8aabtWJNjpQ8OQd0VBlMVMJgzltJoj8QFBE'
// #endregion
// #region META KEYWORDS
export const META_KEYWORDS_ENGLISH: string = `background music, bgm, cheapest music streaming service, music stream, background music streaming, royalties-free music, ${PRODUCT_NAME}`
export const META_KEYWORDS_SPANISH: string = `música de fondo, servicio de streaming de música más barato, transmisión de música, transmisión de música de fondo, ${PRODUCT_NAME}`
export const META_KEYWORDS_FRENCH: string =
  'musique de fond, service de streaming musical le moins cher, streaming musical, streaming de musique de fond, musique libre de droits'
export const META_KEYWORDS_KOREAN: string =
  '배경음악, 가장 저렴한 음악 스트리밍 서비스, 음악 스트리밍, 배경음악 스트리밍, 로열티 프리 음악'
export const META_KEYWORDS_PLAYLIST_ENGLISH: string = `low cost background music streaming service, bgm, cheapest background music streaming, least expensive background music streaming service, most affordable background music streaming service, cheapest background music, business background music, royalties-free music, ${PRODUCT_NAME}`
export const META_KEYWORDS_PLAYLIST_SPANISH: string =
  'Servicio de música de fondo de bajo costo, música de fondo más barata, servicio de música de fondo más económico, servicio de música de fondo más asequible, música de fondo más barata, música de fondo para empresas, música sin regalías'
export const META_KEYWORDS_PLAYLIST_FRENCH: string =
  "service de streaming de musique de fond à bas prix, streaming de musique de fond le moins cher, service de streaming de musique de fond le plus abordable, musique de fond la moins chère, musique de fond d'entreprise, musique libre de droits"
export const META_KEYWORDS_PLAYLIST_KOREAN: string =
  '저렴한 배경 음악 스트리밍 서비스, 가장 저렴한 배경 음악 스트리밍, 가장 저렴한 배경 음악 스트리밍 서비스, 가장 저렴한 배경 음악 스트리밍 서비스, 가장 저렴한 배경 음악, 비즈니스 배경 음악, 로열티 프리 음악'
export const META_KEYWORDS_FAVORITES_ENGLISH: string = `background music, bgm, custom playlists, restaurant music, music for commercial spaces, business background music, preset playlists, radio stations, ${PRODUCT_NAME}`
export const META_KEYWORDS_FAVORITES_SPANISH: string =
  'Música de fondo, listas de reproducción personalizadas para música de fondo, música para restaurantes, música para espacios comerciales, música de fondo para negocios, listas de reproducción preestablecidas para música de fondo, estaciones de radio'
export const META_KEYWORDS_FAVORITES_FRENCH: string =
  "musique de fond, listes de lecture personnalisées, musique de restaurant, musique pour espaces commerciaux, musique de fond d'entreprise, listes de lecture prédéfinies, stations de radio"
export const META_KEYWORDS_FAVORITES_KOREAN: string =
  '배경 음악, 사용자 지정 재생 목록, 레스토랑 음악, 상업 공간 음악, 비즈니스 배경 음악, 사전 설정 재생 목록, 라디오 방송국'
export const META_KEYWORDS_CONTACT_ENGLISH: string = `low price background music, bgm, background music software, business music streaming, lowest price, affordable background music for businesses, ${PRODUCT_NAME}`
export const META_KEYWORDS_CONTACT_SPANISH: string =
  'Música de fondo a bajo precio, software de música de fondo, streaming de música para empresas, el precio más bajo, música de fondo asequible para empresas'
export const META_KEYWORDS_CONTACT_FRENCH: string =
  "musique de fond à bas prix, logiciel de musique de fond, streaming de musique d'entreprise, prix le plus bas, musique de fond abordable pour les entreprises"
export const META_KEYWORDS_CONTACT_KOREAN: string =
  '저렴한 가격의 배경 음악, 배경 음악 소프트웨어, 비즈니스 음악 스트리밍, 최저가, 비즈니스를 위한 저렴한 배경 음악'
// #endregion
// #region OG SITE NAME
export const OG_SITE_NAME: string = PRODUCT_NAME
// #endregion
// #region OG TYPE
export const OG_TYPE: string = 'website'
// #endregion
// #region JSON LD SITE NAME
export const JSON_LD_SITE_NAME: string = PRODUCT_NAME
// #endregion
// #region JSON LD TYPE
export const JSON_LD_TYPE_HOME: string = 'home'
export const JSON_LD_TYPE_CONTACT: string = 'contact'
export const JSON_LD_TYPE_PLAYLIST: string = 'playlist'
export const JSON_LD_TYPE_SETTINGS: string = 'settings'
export const JSON_LD_TYPE_FAVORITES: string = 'favorites'
export const JSON_LD_TYPE_SEARCH: string = 'search'
// #endregion
// #region JSON LD HOME URL
export const JSON_LD_URL_HOME_ENGLISH = HOST
export const JSON_LD_URL_HOME_FRENCH = HOST + '/' + LANGUAGE_CODE_FRENCH + ''
export const JSON_LD_URL_HOME_SPANISH = HOST + '/' + LANGUAGE_CODE_SPANISH + ''
export const JSON_LD_URL_HOME_KOREAN = HOST + '/' + LANGUAGE_CODE_KOREAN + ''
export const JSON_LD_URL_SEARCH_ENGLISH = HOST + '/search'
// #endregion
// #region OG LOCALE
export const OG_LOCALE_ENGLISH_US: string = 'en_US'
export const OG_LOCALE_ENGLISH_GB: string = 'en_GB'
export const OG_LOCALE_FRENCH_FR: string = 'fr_FR'
export const OG_LOCALE_SPANISH_SP: string = 'es_ES'
export const OG_LOCALE_KOREAN_KO: string = 'ko_KR'
// #endregion
// #region OG VIDEO
export const OG_VIDEO_URL: string = 'https://www.youtube.com/v/bg4XYFNT0p4'
export const OG_VIDEO_SECURE_URL: string =
  'https://www.youtube.com/v/bg4XYFNT0p4'
export const OG_VIDEO_WIDTH: string = '400'
export const OG_VIDEO_HEIGHT: string = '300'
export const OG_VIDEO_DURATION: string = '16'
// #endregion
// #region OG PAGE TITLES
export const OG_TITLE_DEFAULT_ENGLISH: string = PRODUCT_NAME
export const OG_TITLE_SETTINGS_ENGLISH: string = 'Access Your Account'
export const OG_TITLE_SETTINGS_SPANISH: string = 'Acceder a tu Cuenta'
export const OG_TITLE_SETTINGS_FRENCH: string = 'Accéder à Votre Compte'
export const OG_TITLE_SETTINGS_KOREAN: string = '귀하의 계정에 액세스하십시오'
export const OG_TITLE_SEARCH_ENGLISH: string = 'Discover Music'
export const OG_TITLE_SEARCH_SPANISH: string = 'Descubra la Música'
export const OG_TITLE_SEARCH_FRENCH: string = 'Découvrez la Musique'
export const OG_TITLE_SEARCH_KOREAN: string = '음악을 발견하다'
export const OG_TITLE_FAVORITES_ENGLISH: string = 'Favorite Music'
export const OG_TITLE_FAVORITES_SPANISH: string = 'Música Favorita'
export const OG_TITLE_FAVORITES_FRENCH: string = 'Musique Préférée'
export const OG_TITLE_FAVORITES_KOREAN: string = '좋아하는 음악'
export const OG_TITLE_PLAYLISTS_ENGLISH: string = 'Create Playlists'
export const OG_TITLE_PLAYLISTS_SPANISH: string = 'Créer Playlists'
export const OG_TITLE_PLAYLISTS_FRENCH: string = 'Crear Listas de Reproducción'
export const OG_TITLE_PLAYLISTS_KOREAN: string = '재생목록 만들기'
export const OG_TITLE_CONTACT_ENGLISH: string = 'Contact Us'
export const OG_TITLE_CONTACT_SPANISH: string = 'Contacta con Nosotrasa'
export const OG_TITLE_CONTACT_FRENCH: string = 'Contactez-nous'
export const OG_TITLE_CONTACT_KOREAN: string = '문의하기'
export const OG_TITLE_400: string = '400 - practical.stream'
export const OG_TITLE_404: string = '404 - practical.stream'
export const OG_TITLE_500: string = '500 - practical.stream'
// #endregion
// #region OG PAGE IMAGES
export const OG_SEARCH_PAGE_IMAGE: string =
  ARWEAVE_GATEWAY_MAIN + '3p0Gz3sZIyCK972hdupp5aLD7koHiny91TjU6HlHCuQ'
export const OG_SETTINGS_PAGE_IMAGE: string =
  ARWEAVE_GATEWAY_MAIN + 'Gsszj1hb_1duvi3eIxis6ZTSD0avH7KgfqwpYLFCNW0'
export const OG_FAVORITES_PAGE_IMAGE: string =
  ARWEAVE_GATEWAY_MAIN + 'VQ_y0IB-ZUCp6KMjjj7VNctalKFJzKPjLq_IlzPIN3w'
export const OG_PLAYLIST_PAGE_IMAGE: string =
  ARWEAVE_GATEWAY_MAIN + 'YWrn3Iq3sj2Y1117-vY4SREug60-QO1ZlPmqRLcBMtk'
export const OG_CONTACT_PAGE_IMAGE: string =
  ARWEAVE_GATEWAY_MAIN + 'hl35KfruBwhqHJfxzwy3Xg6bnn7DNTmk2rfe8m85tBk'
export const OG_FOUR_O_FOUR_PAGE_IMAGE: string =
  ARWEAVE_GATEWAY_MAIN + 'x3bozMkHAj1D9WJHODL_PjSqgj_cY6LQZtBenlhirIA'
export const OG_ERRORS_PAGE_IMAGE: string =
  ARWEAVE_GATEWAY_MAIN + 'x3bozMkHAj1D9WJHODL_PjSqgj_cY6LQZtBenlhirIA'
export const OG_FIVE_HUNDRED_PAGE_IMAGE: string =
  ARWEAVE_GATEWAY_MAIN + 'x3bozMkHAj1D9WJHODL_PjSqgj_cY6LQZtBenlhirIA'
export const OG_HOME_PAGE_IMAGE: string =
  ARWEAVE_GATEWAY_MAIN + 'nTgumqx84phoj_85g2Zpm5i1kJsLVTl9M0x75uOTm2M'
export const OG_HOME_PAGE_IMAGE_SPANISH: string =
  ARWEAVE_GATEWAY_MAIN + 's5qMRrd0gCmmy2UTNeXfpl7uAKKHSp6so5yBznN2vlI'
export const OG_HOME_PAGE_IMAGE_FRENCH: string =
  ARWEAVE_GATEWAY_MAIN + 'ZxwGHV7TsHOH36xtCsVW8AAGOO4fy39ZcSlQQ4bIrKY'
export const OG_HOME_PAGE_IMAGE_KOREAN: string =
  ARWEAVE_GATEWAY_MAIN + '3bTfIEgbXs5Nrgb_BLb3sdYOBc85IePNdKUthb7nURM'
export const OG_IMAGE_WIDTH: string = '1280'
export const OG_IMAGE_HEIGHT: string = '720'
// #endregion
// #region OG PRODUCT IMAGES
export const OG_PRODUCT_IMAGE_WIDTH: string = '1280'
export const OG_PRODUCT_IMAGE_HEIGHT: string = '720'
export const OG_PRODUCT_IMAGE: string =
  ARWEAVE_GATEWAY_MAIN + 'bDwqvtgR-sjhhuR8JpLS3bGkAbWZ-uS_pNSWgCSJnA0'
// #endregion
// #region OG PRODUCT DESCRIPTION
export const OG_PRODUCT_DESCRIPTION_ENGLISH: string =
  'Licensed background music for your business. Easy setup with hardware, software & public performance licensing included.'
export const OG_PRODUCT_DESCRIPTION_FRENCH: string =
  'Transmite música de fondo con licencia para tu negocio. Fácil configuración: incluye hardware, software y licencia de transmisión pública.'
export const OG_PRODUCT_DESCRIPTION_SPANISH: string =
  "Diffusez de la musique d'ambiance sous licence pour votre entreprise. Installation facile: matériel, logiciel et licence de diffusion publique inclus."
export const OG_PRODUCT_DESCRIPTION_KOREAN: string =
  '비즈니스를 위한 라이선스가 있는 배경 음악을 스트리밍하세요. 하드웨어, 소프트웨어 및 공연 라이선스가 포함되어 있어 간편하게 설정할 수 있습니다.'
// #endregion
// #region OG PRODUCT DESCRIPTION
export const META_PRODUCT_DESCRIPTION_ENGLISH: string =
  'Licensed background music for your business. Easy setup with hardware, software & public performance licensing included.'
export const META_PRODUCT_DESCRIPTION_FRENCH: string =
  'Transmite música de fondo con licencia para tu negocio. Fácil configuración: incluye hardware, software y licencia de transmisión pública.'
export const META_PRODUCT_DESCRIPTION_SPANISH: string =
  "Diffusez de la musique d'ambiance sous licence pour votre entreprise. Installation facile: matériel, logiciel et licence de diffusion publique inclus."
export const META_PRODUCT_DESCRIPTION_KOREAN: string =
  '비즈니스를 위한 라이선스가 있는 배경 음악을 스트리밍하세요. 하드웨어, 소프트웨어 및 공연 라이선스가 포함되어 있어 간편하게 설정할 수 있습니다.'
// #endregion
// #region OG PRODUCT IMAGE ALT
export const OG_PRODUCT_IMAGE_LARGE_ALT_ENGLISH: string = `Licensed background music for your business. Easy setup with hardware, software & public performance licensing included.`
export const OG_PRODUCT_IMAGE_LARGE_ALT_SPANISH: string = `Música ambiental con licencia para su negocio. Fácil instalación: incluye hardware, software y licencia de transmisión pública.`
export const OG_PRODUCT_IMAGE_LARGE_ALT_FRENCH: string = `Musique d'ambiance sous licence pour votre entreprise. Installation facile: matériel, logiciel et licence de diffusion publique inclus.`
export const OG_PRODUCT_IMAGE_LARGE_ALT_KOREAN: string = `귀사의 비즈니스를 위한 라이선스 배경음악. 간편한 설치: 하드웨어, 소프트웨어, 공공 방송 라이선스가 포함되어 있습니다.`
// #endregion
// #region JSON LD PRODUCT DESCRIPTION
export const JSON_LD_PRODUCT_DESCRIPTION_ENGLISH: string = `Device for streaming licensed background music in your business. Easy setup with hardware, software & public performance licensing included.`
export const JSON_LD_PRODUCT_DESCRIPTION_SPANISH: string = `Dispositivo para reproducir música de fondo con licencia en su negocio. Fácil instalación: incluye hardware, software y licencia de transmisión pública.`
export const JSON_LD_PRODUCT_DESCRIPTION_FRENCH: string = `Appareil permettant de diffuser de la musique de fond sous licence dans votre entreprise. Installation facile: matériel, logiciel et licence de diffusion publique inclus.`
export const JSON_LD_PRODUCT_DESCRIPTION_KOREAN: string = `사업장에서 라이선스를 받은 배경 음악을 재생하기 위한 장치입니다. 하드웨어, 소프트웨어 및 공연 라이선스가 포함되어 있어 간편하게 설정할 수 있습니다.`
// #endregion
// #region JSON LD PRODUCT IMAGES
export const GOOGLE_RICH_RESULTS_PRODUCT_IMAGE_1_X_1: string =
  ARWEAVE_GATEWAY_MAIN + 'OfAzAn2oSEM8ySrumCz_Xq7uSkDvA3wb1umqpYoHSPw'
export const GOOGLE_RICH_RESULTS_PRODUCT_IMAGE_4_X_3: string =
  ARWEAVE_GATEWAY_MAIN + 'KX39oo7v9Un-MhFz7m3WjJpMksXUgiBx_SsJqvBgrE8'
export const GOOGLE_RICH_RESULTS_PRODUCT_IMAGE_16_X_9: string =
  ARWEAVE_GATEWAY_MAIN + '9ubEaZtNmGAufmUUSj2UNspn7jas1CoB644UK6tBxyg'
export const JSON_LD_PRODUCT_IMAGE_1_X_1_DEVICE_VARIANT: string =
  ARWEAVE_GATEWAY_MAIN + '9jFiusB3d5PhcFfgsy2w1232bg6GTvJhy3WuVX8LxfI'
export const JSON_LD_PRODUCT_IMAGE_4_X_3_DEVICE_VARIANT: string =
  ARWEAVE_GATEWAY_MAIN + 'qZVkdTbj4N7m8kNxtKQVQ5-sJrVpPOVGncAFcrathkI'
export const JSON_LD_PRODUCT_IMAGE_16_X_9_DEVICE_VARIANT: string =
  ARWEAVE_GATEWAY_MAIN + 'FnE1FWo1wuuTP2D1AzC7QUL4q8752KDVfKv90wa3HDU'
// #endregion
// #region HOME / DEFAULT META DESCRIPTION
export const META_DESCRIPTION_DEFAULT_ENGLISH: string = `Discover the best background music service for your store, restaurant, bar, club, spa, gym, or office. Our product, called ${PRODUCT_NAME}, provides the cheapest business music streaming with premium sound quality. Much less expensive than ${CLOUD_COVER_PRODUCT_NAME}, ${PANDORA_BRAND_NAME}, ${MOOD_MEDIA_PRODUCT_NAME}, ${JUKEBOXY_PRODUCT_NAME}, ${SOUNDTRACK_YOUR_BRAND_PRODUCT_NAME}, ${ROCKBOT_PRODUCT_NAME}, and an ASCAP, BMI or SESAC license.`
export const META_DESCRIPTION_HOME_ENGLISH: string = `Discover the best background music service for your store, restaurant, bar, club, spa, gym, or office. Our product, called ${PRODUCT_NAME}, provides the cheapest business music streaming with premium sound quality. Much less expensive than ${CLOUD_COVER_PRODUCT_NAME}, ${PANDORA_BRAND_NAME}, ${MOOD_MEDIA_PRODUCT_NAME}, ${JUKEBOXY_PRODUCT_NAME}, ${SOUNDTRACK_YOUR_BRAND_PRODUCT_NAME}, ${ROCKBOT_PRODUCT_NAME}, and an ASCAP, BMI or SESAC license.`
export const META_DESCRIPTION_HOME_SPANISH: string = `Encuentre el servicio de música ambiental perfecto para su tienda, restaurante, bar, discoteca, spa, gimnasio u oficina. Nuestro producto ofrece el servicio de streaming de música más económico con una calidad de sonido superior. Mucho más barato que ${CLOUD_COVER_PRODUCT_NAME}, ${PANDORA_BRAND_NAME}, ${MOOD_MEDIA_PRODUCT_NAME}, ${JUKEBOXY_PRODUCT_NAME}, ${SOUNDTRACK_YOUR_BRAND_PRODUCT_NAME}, ${ROCKBOT_PRODUCT_NAME} y las licencias de ASCAP, BMI o SESAC.`
export const META_DESCRIPTION_HOME_FRENCH: string = `Trouvez le service de musique d'ambiance idéal pour votre magasin, restaurant, bar, discothèque, spa, salle de sport ou bureau. Notre service de streaming musical est le plus abordable du marché et offre une qualité sonore exceptionnelle.  Bien moins cher que ${CLOUD_COVER_PRODUCT_NAME}, ${PANDORA_BRAND_NAME}, ${MOOD_MEDIA_PRODUCT_NAME}, ${JUKEBOXY_PRODUCT_NAME}, ${SOUNDTRACK_YOUR_BRAND_PRODUCT_NAME}, ${ROCKBOT_PRODUCT_NAME} et les licences d'ASCAP, BMI ou SESAC.`
export const META_DESCRIPTION_HOME_KOREAN: string = `매장, 레스토랑, 바, 나이트클럽, 스파, 헬스장 또는 사무실에 딱 맞는 배경 음악 서비스를 찾아보세요. 저희 음악 스트리밍 서비스는 시중에서 가장 저렴하면서도 뛰어난 음질을 제공합니다. ${CLOUD_COVER_PRODUCT_NAME}, ${PANDORA_BRAND_NAME}, ${MOOD_MEDIA_PRODUCT_NAME}, ${JUKEBOXY_PRODUCT_NAME}, ${SOUNDTRACK_YOUR_BRAND_PRODUCT_NAME}, ${ROCKBOT_PRODUCT_NAME} 등의 서비스나 ASCAP, BMI, SESAC의 라이선스보다 훨씬 저렴합니다.`
// #endregion
// #region SEARCH META DESCRIPTION
export const META_DESCRIPTION_SEARCH_ENGLISH: string = `Discover new music for your store, restaurant, or other commercial space with our product, called ${PRODUCT_NAME}: background music for business.`
export const META_DESCRIPTION_SEARCH_SPANISH: string =
  'Descubra música nueva para su tienda, restaurante u otro espacio comercial con nuestro producto, el servicio de música ambiental para negocios más económico y con todas las funciones.'
export const META_DESCRIPTION_SEARCH_FRENCH: string =
  "Découvrez de nouvelles musiques pour votre magasin, restaurant ou autre espace commercial grâce à notre produit, le service de musique d'ambiance le plus abordable et le plus complet pour les entreprises."
export const META_DESCRIPTION_SEARCH_KOREAN: string =
  '저희 제품을 통해 매장, 레스토랑 또는 기타 상업 공간에 어울리는 새로운 음악을 발견해 보세요. 저희는 기업을 위한 가장 저렴하고 기능이 풍부한 배경 음악 서비스를 제공합니다.'
// #endregion
// #region CONTACT META DESCRIPTION
export const META_DESCRIPTION_CONTACT_ENGLISH: string =
  "Need assistance with background music streaming or have a question? Contact us for support, integration questions, or collaboration inquiries. We're here to help."
export const META_DESCRIPTION_CONTACT_SPANISH: string =
  '¿Necesita asistencia o tiene preguntas relacionadas con la transmisión de música de fondo? No dude en contactarnos para obtener soporte, consultar sobre integraciones o proponer colaboraciones. Siempre estamos a su disposición para ayudarle.'
export const META_DESCRIPTION_CONTACT_FRENCH: string =
  "Avez-vous besoin d'aide ou avez-vous des questions concernant la diffusion de musique d'ambiance en streaming ? N'hésitez pas à nous contacter pour obtenir de l'assistance, pour toute question relative aux intégrations ou pour proposer des collaborations. Nous sommes toujours là pour vous aider."
export const META_DESCRIPTION_CONTACT_KOREAN: string =
  '배경 음악 스트리밍 관련 지원이 필요하시거나 질문이 있으신가요? 지원, 통합 관련 문의 또는 협업 제안에 대해 저희에게 연락주세요. 저희는 언제든 도와드릴 준비가 되어 있습니다.'
// #endregion
// #region PLAYLISTS META DESCRIPTION
export const META_DESCRIPTION_PLAYLISTS_ENGLISH: string = `Discover high-quality and cheap price music streaming for your business. Our product, called ${PRODUCT_NAME} delivers premium audio with the market's lowest price.`
export const META_DESCRIPTION_PLAYLISTS_SPANISH: string =
  'Descubra la transmisión de música de alta calidad a precios asequibles para su negocio. Nuestro servicio ofrece audio de primera calidad al precio más bajo del mercado.'
export const META_DESCRIPTION_PLAYLISTS_FRENCH: string =
  'Découvrez un service de streaming musical de haute qualité à des prix abordables pour votre entreprise. Notre service vous offre un son exceptionnel au prix le plus bas du marché.'
export const META_DESCRIPTION_PLAYLISTS_KOREAN: string =
  '귀사를 위한 고품질 음악 스트리밍 서비스를 합리적인 가격으로 만나보세요. 저희 서비스는 시장 최저가로 탁월한 음질을 제공합니다.'
// #endregion
// #region FAVORITES META DESCRIPTION
export const META_DESCRIPTION_FAVORITES_ENGLISH: string = `Create custom playlists and favorites. Curated tracks perfect for every vibe— discover the soundtrack for your commercial space with our product, called ${PRODUCT_NAME}.`
export const META_DESCRIPTION_FAVORITES_SPANISH: string =
  'Crea listas de reproducción personalizadas y guarda tus canciones favoritas. Descubre la música ambiental ideal que se adapta perfectamente al ambiente de tu tienda con nuestra cuidada selección de temas musicales.'
export const META_DESCRIPTION_FAVORITES_FRENCH: string =
  "Créez des playlists personnalisées et enregistrez vos morceaux préférés. Découvrez la musique d'ambiance idéale qui s'adapte parfaitement à l'atmosphère de votre magasin grâce à notre sélection de titres soigneusement choisis."
export const META_DESCRIPTION_FAVORITES_KOREAN: string =
  '맞춤형 재생 목록을 만들고 좋아하는 곡을 저장하세요. 저희가 엄선한 트랙들을 통해 매장 분위기에 완벽하게 어울리는 이상적인 배경 음악을 찾아보세요.'
// #endregion
// #region SETTINGS META DESCRIPTION
export const META_DESCRIPTION_SETTINGS_ENGLISH: string =
  "Log in to stream music that's licensed to play in your place of business."
export const META_DESCRIPTION_SETTINGS_SPANISH: string =
  'Inicie sesión para transmitir música autorizada para su uso en su establecimiento comercial.'
export const META_DESCRIPTION_SETTINGS_FRENCH: string =
  'Connectez-vous pour diffuser de la musique autorisée à être utilisée dans votre établissement commercial.'
export const META_DESCRIPTION_SETTINGS_KOREAN: string =
  '귀하의 사업장에서 스트리밍이 허가된 음악을 스트리밍하려면 로그인하세요.'
// #endregion
// #region 404, 400, 500 META DESCRIPTION
export const META_DESCRIPTION_404: string = '404 - practical.stream'
export const META_DESCRIPTION_400: string = '400 - practical.stream'
export const META_DESCRIPTION_500: string = '500 - practical.stream'
// #endregion
// #region HOME / DEFAULT OG DESCRIPTION
export const OG_DESCRIPTION_DEFAULT_ENGLISH: string =
  'Licensed background music for your business. Easy setup with hardware, software & public performance licensing included.'
export const OG_DESCRIPTION_HOME_ENGLISH: string =
  'Licensed background music for your business. Easy setup with hardware, software & public performance licensing included.'
export const OG_DESCRIPTION_HOME_SPANISH: string =
  'Transmite música de fondo con licencia para tu negocio. Fácil configuración: incluye hardware, software y licencia de transmisión pública.'
export const OG_DESCRIPTION_HOME_FRENCH: string =
  "Diffusez de la musique d'ambiance sous licence pour votre entreprise. Installation facile: matériel, logiciel et licence de diffusion publique inclus."
export const OG_DESCRIPTION_HOME_KOREAN: string =
  '비즈니스를 위한 라이선스가 있는 배경 음악을 스트리밍하세요. 하드웨어, 소프트웨어 및 공연 라이선스가 포함되어 있어 간편하게 설정할 수 있습니다.'
// #endregion
// #region SEARCH OG DESCRIPTION
export const OG_DESCRIPTION_SEARCH_ENGLISH: string =
  'Discover new music to play in your store, restaurant, or other commercial space.'
export const OG_DESCRIPTION_SEARCH_SPANISH: string =
  'Descubra nueva música para reproducir en su tienda minorista o restaurante.'
export const OG_DESCRIPTION_SEARCH_FRENCH: string =
  'Découvrez de nouvelles musiques à diffuser dans votre magasin de détail ou votre restaurant.'
export const OG_DESCRIPTION_SEARCH_KOREAN: string =
  '소매점이나 레스토랑 사업에서 재생할 새로운 음악을 찾아보세요.'
// #endregion
// #region CONTACT OG DESCRIPTION
export const OG_DESCRIPTION_CONTACT_ENGLISH: string =
  'Contact us for expert help with business background music streaming, music licensing, or technical support with our service.'
export const OG_DESCRIPTION_CONTACT_SPANISH: string =
  'Contáctenos para obtener ayuda experta en transmisión de música ambiental para negocios, licencias musicales o soporte técnico para nuestro servicio.'
export const OG_DESCRIPTION_CONTACT_FRENCH: string =
  "Contactez-nous pour obtenir l'aide d'experts en matière de diffusion de musique d'ambiance pour entreprises, de licences musicales ou d'assistance technique concernant notre service."
export const OG_DESCRIPTION_CONTACT_KOREAN: string =
  '사업장 배경 음악 스트리밍, 음악 라이선스 또는 서비스 관련 기술 지원에 대한 전문가의 도움이 필요하시면 저희에게 문의하십시오.'
// #endregion
// #region PLAYLISTS OG DESCRIPTION
export const OG_DESCRIPTION_PLAYLISTS_ENGLISH: string =
  'Get licensed music for your venue with bundled streaming, hardware and a public performance license in one simple solution.'
export const OG_DESCRIPTION_PLAYLISTS_SPANISH: string =
  'Obtenga música legal para su lugar con licencias de transmisión, hardware y ejecución pública agrupadas en una solución sencilla.'
export const OG_DESCRIPTION_PLAYLISTS_FRENCH: string =
  'Obtenez de la musique légale pour votre salle avec des licences de streaming, de matériel et de représentation publique groupées dans une solution simple.'
export const OG_DESCRIPTION_PLAYLISTS_KOREAN: string =
  '스트리밍, 하드웨어 및 공연 라이선스를 하나의 간단한 솔루션으로 묶어 공연장에서 합법적으로 음악을 즐기세요.'
// #endregion
// #region FAVORITES OG DESCRIPTION
export const OG_DESCRIPTION_FAVORITES_ENGLISH: string =
  'We simplify background music licensing with bundled tech & streaming. Trusted by businesses for legal music playback.'
export const OG_DESCRIPTION_FAVORITES_SPANISH: string =
  'Simplificamos la licencia de música ambiental con nueva tecnología. Muchas empresas confían en nosotros para la transmisión de música con licencia.'
export const OG_DESCRIPTION_FAVORITES_FRENCH: string =
  "Nous simplifions l'obtention de licences pour la musique d'ambiance grâce à une nouvelle technologie. De nombreuses entreprises nous font confiance pour le streaming musical sous licence."
export const OG_DESCRIPTION_FAVORITES_KOREAN: string =
  '최첨단 기술로 배경 음악 라이선스를 간소화하세요. 라이선스 음악 스트리밍 서비스로 많은 기업의 신뢰를 받고 있습니다.'
// #endregion
// #region SETTINGS OG DESCRIPTION
export const OG_DESCRIPTION_SETTINGS_ENGLISH: string =
  "Log in to stream music that's licensed to play in your place of business."
export const OG_DESCRIPTION_SETTINGS_SPANISH: string =
  'Inicie sesión para transmitir música autorizada para su uso en su establecimiento comercial.'
export const OG_DESCRIPTION_SETTINGS_FRENCH: string =
  'Connectez-vous pour diffuser de la musique autorisée à être utilisée dans votre établissement commercial.'
export const OG_DESCRIPTION_SETTINGS_KOREAN: string =
  '귀하의 사업장에서 스트리밍이 허가된 음악을 스트리밍하려면 로그인하세요.'
// #endregion
// #region 404, 400, 500 OG DESCRIPTION
export const OG_DESCRIPTION_404: string = '404 - practical.stream'
export const OG_DESCRIPTION_400: string = '400 - practical.stream'
export const OG_DESCRIPTION_500: string = '500 - practical.stream'
// #endregion
// #region HOME / DEFAULT TITLE TAG
export const TITLE_TAG_DEFAULT_ENGLISH: string = `Premium Background Music for Businesses | ${PRODUCT_NAME}`
export const TITLE_TAG_DEFAULT_SPANISH: string = `Música de Fondo Premium en Streaming | ${PRODUCT_NAME}`
export const TITLE_TAG_DEFAULT_FRENCH: string = `Musique de Fond Premium en Streaming | ${PRODUCT_NAME}`
export const TITLE_TAG_DEFAULT_KOREAN: string = `프리미엄 배경음악 스트리밍 | ${PRODUCT_NAME}`
export const TITLE_TAG_HOME_ENGLISH: string = `Premium Background Music Streaming | ${PRODUCT_NAME}`
export const TITLE_TAG_HOME_SPANISH: string = `Música de Fondo Premium en Streaming | ${PRODUCT_NAME}`
export const TITLE_TAG_HOME_FRENCH: string = `Musique de Fond Premium en Streaming | ${PRODUCT_NAME}`
export const TITLE_TAG_HOME_KOREAN: string = `프리미엄 배경음악 스트리밍 | ${PRODUCT_NAME}`
export const TITLE_TAG_HOME_ENGLISH_USER: string = `Premium Background Music for Businesses | ${PRODUCT_NAME}`
export const TITLE_TAG_HOME_SPANISH_USER: string = `Música de Fondo Premium en Streaming | ${PRODUCT_NAME}`
export const TITLE_TAG_HOME_FRENCH_USER: string = `Musique de Fond Premium en Streaming | ${PRODUCT_NAME}`
export const TITLE_TAG_HOME_KOREAN_USER: string = `프리미엄 배경음악 스트리밍 | ${PRODUCT_NAME}`
// #endregion
// #region SETTINGS TITLE TAG
export const TITLE_TAG_SETTINGS_ENGLISH: string = `Settings - ${PRODUCT_NAME}`
export const TITLE_TAG_SETTINGS_SPANISH: string = `Ajustes - ${PRODUCT_NAME}`
export const TITLE_TAG_SETTINGS_FRENCH: string = `Paramètres - ${PRODUCT_NAME}`
export const TITLE_TAG_SETTINGS_KOREAN: string = `계정 설정 - ${PRODUCT_NAME}`
// #endregion
// #region CONTACT TITLE TAG
export const TITLE_TAG_CONTACT_ENGLISH: string = `Contact Us | ${PRODUCT_NAME}`
export const TITLE_TAG_CONTACT_SPANISH: string =
  'Contacta con Nosotras | Soporte Música de Fondo'
export const TITLE_TAG_CONTACT_FRENCH: string =
  'Contactez-nous | Assistance Musique de Fond'
export const TITLE_TAG_CONTACT_KOREAN: string = '문의하기 | 배경 음악 관련 지원'
// #endregion
// #region PLAYLISTS TITLE TAG
export const TITLE_TAG_PLAYLISTS_ENGLISH: string = `The Best Background Music Playlists at the Lowest Price | ${PRODUCT_NAME}`
export const TITLE_TAG_PLAYLISTS_SPANISH: string = `Las Mejores Listas de Reproducción de Música de Fondo al Precio más Bajo | ${PRODUCT_NAME}`
export const TITLE_TAG_PLAYLISTS_FRENCH: string = `Les Meilleures Playlists de Musique d'ambiance au Prix le Plus Bas | ${PRODUCT_NAME}`
export const TITLE_TAG_PLAYLISTS_KOREAN: string =
  '최저가로 최고의 배경 음악 플레이리스트를 만나보세요'
// #endregion
// #region FAVORITES TITLE TAG
export const TITLE_TAG_FAVORITES_ENGLISH: string =
  'Business Background Music | Favorite Songs Hub'
export const TITLE_TAG_FAVORITES_SPANISH: string =
  'Música de Fondo para Negocios | Colección de Canciones Favoritas'
export const TITLE_TAG_FAVORITES_FRENCH: string =
  "Musique d'ambiance pour les Entreprises | Collection de Chansons Préférées"
export const TITLE_TAG_FAVORITES_KOREAN: string =
  '사업장 배경 음악 | 좋아하는 노래 모음'
// #endregion
// #region SEARCH TITLE TAG
export const TITLE_TAG_SEARCH_ENGLISH: string = `Search For Songs - ${PRODUCT_NAME}`
export const TITLE_TAG_SEARCH_SPANISH: string = `Buscar Canciones - ${PRODUCT_NAME}`
export const TITLE_TAG_SEARCH_FRENCH: string = `Rechercher des Chansons - ${PRODUCT_NAME}`
export const TITLE_TAG_SEARCH_KOREAN: string = `노래 검색 - ${PRODUCT_NAME}`
// #endregion
// #region ERROR TITLE TAG
export const TITLE_TAG_ERROR_ENGLISH: string = 'Error'
export const TITLE_TAG_ERROR_SPANISH: string = 'Error'
export const TITLE_TAG_ERROR_FRENCH: string = 'Erreur'
export const TITLE_TAG_ERROR_KOREAN: string = '오류'
// #endregion
// #region 400, 404, 500 TITLE TAG
export const TITLE_TAG_400: string = '400'
export const TITLE_TAG_404: string = '404'
export const TITLE_TAG_500: string = '500'
// #endregion
// #region HOME_PAGE_DISCOUNT_MUSIC_IMG_ALT
export const HOME_PAGE_DISCOUNT_MUSIC_IMG_ALT_ENGLISH: string =
  'Get amazing background music licensed to restaurants, retailers, bars and more.'
export const HOME_PAGE_DISCOUNT_MUSIC_IMG_ALT_SPANISH: string =
  'Obtenga increíble música de fondo con licencia para restaurantes, minoristas, bares y más.'
export const HOME_PAGE_DISCOUNT_MUSIC_IMG_ALT_FRENCH: string =
  'Obtenez une musique de fond incroyable sous licence pour les restaurants, les détaillants, les bars et plus encore.'
export const HOME_PAGE_DISCOUNT_MUSIC_IMG_ALT_KOREAN: string =
  '레스토랑, 소매점, 바 등에 라이선스를 부여한 놀라운 배경 음악을 받아보세요.'
// #endregion
// #region HOME_PAGE_SAVE_MONEY_IMG_ALT
export const HOME_PAGE_SAVE_MONEY_IMG_ALT_ENGLISH: string =
  'Save money with premium business background music.'
export const HOME_PAGE_SAVE_MONEY_IMG_ALT_SPANISH: string =
  'Ahorra dinero con música premium de negocios.'
export const HOME_PAGE_SAVE_MONEY_IMG_ALT_FRENCH: string =
  'Économisez avec de la musique professionnelle premium.'
export const HOME_PAGE_SAVE_MONEY_IMG_ALT_KOREAN: string =
  '프리미엄 비즈니스 음악으로 비용을 절약하세요.'
// #endregion
// #region HOME_PAGE_PEACE_OF_MIND_IMG_ALT
export const HOME_PAGE_PEACE_OF_MIND_IMG_ALT_ENGLISH: string =
  'Get royalties-free commercial background music.'
export const HOME_PAGE_PEACE_OF_MIND_IMG_ALT_SPANISH: string =
  'Consigue música de fondo libre de derechos de autor.'
export const HOME_PAGE_PEACE_OF_MIND_IMG_ALT_FRENCH: string =
  'Obtenez de la musique de fond libre de droits.'
export const HOME_PAGE_PEACE_OF_MIND_IMG_ALT_KOREAN: string =
  '저작권료가 없는 배경 음악을 스트리밍하세요.'
// #endregion
// #region HOME_PAGE_DISCOUNT_MUSIC_IMG_ALT
export const HOME_PAGE_STREAM_TODAY_IMG_ALT_ENGLISH: string = `Start streaming hip background music for your business today. Our product is much less expensive than ${PANDORA_BRAND_NAME}, ${CLOUD_COVER_PRODUCT_NAME}, ${JUKEBOXY_PRODUCT_NAME}, ${ROCKBOT_PRODUCT_NAME}, ${MOOD_MEDIA_PRODUCT_NAME}, ${SOUNDTRACK_YOUR_BRAND_PRODUCT_NAME}, an ASCAP license, BMI license, or a SESAC license.`
export const HOME_PAGE_STREAM_TODAY_IMG_ALT_SPANISH: string = `Empieza hoy mismo a reproducir música ambiental de moda en tu negocio. Nuestro servicio es mucho más económico que ${PANDORA_BRAND_NAME}, ${CLOUD_COVER_PRODUCT_NAME}, ${JUKEBOXY_PRODUCT_NAME}, ${ROCKBOT_PRODUCT_NAME}, ${MOOD_MEDIA_PRODUCT_NAME}, ${SOUNDTRACK_YOUR_BRAND_PRODUCT_NAME}, una licencia de ASCAP, una licencia de BMI o una licencia de SESAC.`
export const HOME_PAGE_STREAM_TODAY_IMG_ALT_FRENCH: string = `Commencez dès aujourd'hui à diffuser de la musique d'ambiance tendance pour votre entreprise. Notre service est beaucoup moins cher que ${PANDORA_BRAND_NAME}, ${CLOUD_COVER_PRODUCT_NAME}, ${JUKEBOXY_PRODUCT_NAME}, ${ROCKBOT_PRODUCT_NAME}, ${MOOD_MEDIA_PRODUCT_NAME}, ${SOUNDTRACK_YOUR_BRAND_PRODUCT_NAME}, une licence ASCAP, une licence BMI ou une licence SESAC.`
export const HOME_PAGE_STREAM_TODAY_IMG_ALT_KOREAN: string = `지금 바로 귀사의 사업장을 위한 세련된 배경 음악 스트리밍 서비스를 시작하세요. 저희 서비스는 ${PANDORA_BRAND_NAME}, ${CLOUD_COVER_PRODUCT_NAME}, ${JUKEBOXY_PRODUCT_NAME}, ${ROCKBOT_PRODUCT_NAME}, ${MOOD_MEDIA_PRODUCT_NAME}, ${SOUNDTRACK_YOUR_BRAND_PRODUCT_NAME}, ASCAP 라이선스, BMI 라이선스 또는 SESAC 라이선스보다 훨씬 저렴합니다.`
// #endregion
// #region COVER_ART_IMG_ALT
export const COVER_ART_IMG_ALT_ENGLISH: string = `Play thousands of premium songs like this one in your business.`
export const COVER_ART_IMG_ALT_SPANISH: string = `Reproduce miles de canciones premium como ésta en tu negocio.`
export const COVER_ART_IMG_ALT_FRENCH: string = `Écoutez des milliers de chansons premium comme celle-ci dans votre entreprise.`
export const COVER_ART_IMG_ALT_KOREAN: string = `귀하의 사업장에서 이와 같은 수천 곡의 프리미엄 노래를 재생해 보세요.`
// #endregion
// #region JSON LD SOFTWARE APPLICATION ABOUT
export const JSON_LD_APPLICATION_ABOUT_DEFAULT: string =
  'Licensed music streaming software for commercial spaces.'
export const JSON_LD_APPLICATION_ABOUT_ENGLISH: string =
  'Licensed music streaming software for commercial spaces.'
export const JSON_LD_APPLICATION_ABOUT_SPANISH: string =
  'Software de transmisión de música con licencia para espacios comerciales.'
export const JSON_LD_APPLICATION_ABOUT_FRENCH: string =
  'Logiciel de diffusion de musique sous licence pour les espaces commerciaux.'
export const JSON_LD_APPLICATION_ABOUT_KOREAN: string =
  '상업 공간용으로 라이선스가 부여된 음악 스트리밍 소프트웨어입니다.'
// #endregion
// #region JSON LD SOFTWARE APPLICATION ABOUT
export const JSON_LD_SOFTWARE_ONLY_OFFER_DESCRIPTION_DEFAULT: string =
  'Business background music streaming subscription for professional spaces.\n\nKey features include:\n- Thousands of licensed songs\n- Autoplay and stop scheduling\n- Multi-user and multi-location support\n- Preset and customizable playlists\n- A dedicated hardware device (optional).'
export const JSON_LD_SOFTWARE_ONLY_OFFER_DESCRIPTION_ES: string =
  'Suscripción de streaming de música ambiental para negocios y espacios profesionales.\n\nFunciones clave:\n- Miles de canciones con licencia\n- Programación de inicio y parada automática\n- Soporte multiusuario y multiubicación\n- Listas de reproducción preestablecidas y personalizables\n- Un dispositivo de hardware específico (opcional).'
export const JSON_LD_SOFTWARE_ONLY_OFFER_DESCRIPTION_FR: string =
  'Abonnement de streaming musical professionnel pour les espaces commerciaux.\n\nCaractéristiques principales :\n- Des milliers de titres sous licence\n- Programmation automatique (lecture et arrêt)\n- Gestion multi-utilisateurs et multi-sites\n- Listes de lecture prédéfinies et personnalisables\n- Un appareil matériel dédié (en option).'
export const JSON_LD_SOFTWARE_ONLY_OFFER_DESCRIPTION_KO: string =
  '상업 공간을 위한 비즈니스 배경 음악 스트리밍 구독 서비스입니다.\n\n주요 기능:\n- 수천 곡의 라이선스 음원 보유\n- 자동 재생 및 정지 예약 설정\n- 다중 사용자 및 다중 지점 관리 지원\n- 사전 설정 및 맞춤형 플레이리스트 제공\n- 전용 하드웨어 장치(선택 사항).'
// #endregion
// #region JSON LD GENERIC PRODUCT DESCRIPTION OF COMPETITORS
export const JSON_LD_PRODUCT_GENERIC_DESCRIPTION_FOR_COMPETITORS: string =
  'Enterprise-level background music streaming service for businesses.'
export const JSON_LD_PRODUCT_GENERIC_DESCRIPTION_FOR_COMPETITORS_ES: string =
  'Servicio de transmisión de música de fondo de calidad profesional para empresas.'
export const JSON_LD_PRODUCT_GENERIC_DESCRIPTION_FOR_COMPETITORS_FR: string =
  "Service de diffusion de musique d'ambiance de qualité professionnelle pour les entreprises."
export const JSON_LD_PRODUCT_GENERIC_DESCRIPTION_FOR_COMPETITORS_KO: string =
  '기업을 위한 엔터프라이즈급 배경 음악 스트리밍 서비스.'
// #endregion
// #region
export const JSON_LD_PRODUCT_IMAGE_ICON_GENERIC_COMPETITOR_DESCRIPTION: string =
  'Generic B2B music streaming service provider icon'
export const JSON_LD_PRODUCT_IMAGE_ICON_GENERIC_COMPETITOR_DESCRIPTION_ES: string =
  'Icono genérico de proveedor de servicios de transmisión de música B2B'
export const JSON_LD_PRODUCT_IMAGE_ICON_GENERIC_COMPETITOR_DESCRIPTION_FR: string =
  'Icône du fournisseur de services de diffusion de musique en continu B2B générique'
export const JSON_LD_PRODUCT_IMAGE_ICON_GENERIC_COMPETITOR_DESCRIPTION_KO: string =
  '일반적인 B2B 음악 스트리밍 서비스 제공업체 아이콘'
// #endregion
// #region
export const JSON_LD_PRODUCT_IMAGE_ICON_GENERIC_COMPETITOR_FURTHER_DESCRIPTION: string =
  'Abstract musical note icon representing a commercial background music service provider.'
export const JSON_LD_PRODUCT_IMAGE_ICON_GENERIC_COMPETITOR_FURTHER_DESCRIPTION_ES: string =
  'Icono abstracto de una nota musical que representa a un proveedor de servicios de música ambiental para comercios.'
export const JSON_LD_PRODUCT_IMAGE_ICON_GENERIC_COMPETITOR_FURTHER_DESCRIPTION_FR: string =
  "Une icône abstraite représentant une note de musique, symbolisant un fournisseur de services de musique d'ambiance pour les entreprises."
export const JSON_LD_PRODUCT_IMAGE_ICON_GENERIC_COMPETITOR_FURTHER_DESCRIPTION_KO: string =
  '기업을 위한 배경 음악 서비스 제공업체를 상징하는 추상적인 음표 아이콘입니다.'
// #endregion
// #region JSON LD ORGANIZATION DESCRIPTION
export const JSON_LD_ORGANIZATION_DESCRIPTION_DEFAULT: string =
  'Music streaming service for restaurants, bars, nightclubs, gyms, retail stores and other commercial spaces.'
export const JSON_LD_ORGANIZATION_DESCRIPTION_ENGLISH: string =
  'Music streaming service for restaurants, bars, nightclubs, gyms, retail stores and other commercial spaces.'
export const JSON_LD_ORGANIZATION_DESCRIPTION_SPANISH: string =
  'Servicio de transmisión de música para restaurantes, bares, discotecas, gimnasios, tiendas minoristas y otros espacios comerciales.'
export const JSON_LD_ORGANIZATION_DESCRIPTION_FRENCH: string =
  'Service de streaming musical pour restaurants, bars, discothèques, salles de sport, magasins de détail et autres espaces commerciaux.'
export const JSON_LD_ORGANIZATION_DESCRIPTION_KOREAN: string =
  '레스토랑, 바, 나이트클럽, 체육관, 소매점 및 기타 상업 공간을 위한 음악 스트리밍 서비스입니다.'
// #endregion
// #region OG URL
export const OG_URL_HOME_ENGLISH = HOST
export const OG_URL_HOME_FRENCH = HOST + '/' + LANGUAGE_CODE_FRENCH + ''
export const OG_URL_HOME_SPANISH = HOST + '/' + LANGUAGE_CODE_SPANISH + ''
export const OG_URL_HOME_KOREAN = HOST + '/' + LANGUAGE_CODE_KOREAN + ''
export const OG_URL_SEARCH_ENGLISH = HOST + '/search'
export const OG_URL_SEARCH_FRENCH =
  HOST + '/' + LANGUAGE_CODE_FRENCH + '/trouve'
export const OG_URL_SEARCH_SPANISH =
  HOST + '/' + LANGUAGE_CODE_SPANISH + '/buscar'
export const OG_URL_SEARCH_KOREAN = HOST + '/' + LANGUAGE_CODE_KOREAN + '/찾기'
export const OG_URL_PLAYLIST_ENGLISH = HOST + '/playlist'
export const OG_URL_PLAYLIST_FRENCH =
  HOST + '/' + LANGUAGE_CODE_FRENCH + '/playlist'
export const OG_URL_PLAYLIST_SPANISH =
  HOST + '/' + LANGUAGE_CODE_SPANISH + '/playlist'
export const OG_URL_PLAYLIST_KOREAN =
  HOST + '/' + LANGUAGE_CODE_KOREAN + '/재생목록'
export const OG_URL_FAVORITES_ENGLISH = HOST + '/favorites'
export const OG_URL_FAVORITES_FRENCH =
  HOST + '/' + LANGUAGE_CODE_FRENCH + '/favoris'
export const OG_URL_FAVORITES_SPANISH =
  HOST + '/' + LANGUAGE_CODE_SPANISH + '/favoritas'
export const OG_URL_FAVORITES_KOREAN =
  HOST + '/' + LANGUAGE_CODE_KOREAN + '/좋아하는'
export const OG_URL_CONTACT_ENGLISH = HOST + '/contact'
export const OG_URL_CONTACT_FRENCH =
  HOST + '/' + LANGUAGE_CODE_FRENCH + '/contact'
export const OG_URL_CONTACT_SPANISH =
  HOST + '/' + LANGUAGE_CODE_SPANISH + '/contacto'
export const OG_URL_CONTACT_KOREAN =
  HOST + '/' + LANGUAGE_CODE_KOREAN + '/문의하기'
export const OG_URL_SETTINGS_ENGLISH = HOST + '/settings'
export const OG_URL_SETTINGS_FRENCH =
  HOST + '/' + LANGUAGE_CODE_FRENCH + '/settings'
export const OG_URL_SETTINGS_SPANISH =
  HOST + '/' + LANGUAGE_CODE_SPANISH + '/settings'
export const OG_URL_SETTINGS_KOREAN =
  HOST + '/' + LANGUAGE_CODE_KOREAN + '/settings'
// #endregion
// #region JSON LD SOFTWARE APPLICATION KEYWORDS
export const JSON_LD_SOFTWARE_APPLICATION_KEYWORDS_FRENCH: string =
  '"musique", "diffusion", "restaurant", "vente au détail", "magasins", "barres", "boîte de nuit", "droits de auteur"'
export const JSON_LD_SOFTWARE_APPLICATION_KEYWORDS_SPANISH: string =
  '"música", "transmisión", "minorista", "restaurante", "historias", "barras", "club nocturno", "derechos de autor"'
export const JSON_LD_SOFTWARE_APPLICATION_KEYWORDS_KOREAN: string =
  '"음악", "스트리밍", "소매", "식당", "백화점", "이더 리움", "바", "나이트클럽","저작권", "라이센스"'
export const JSON_LD_SOFTWARE_APPLICATION_KEYWORDS_ENGLISH: string =
  '"music", "streaming", "retail", "restaurant", "stores", "bars", "nightclubs", "copyright", "licensed"'
// #endregion

export function getInitialPageMetadata(
  pageComponent: string,
  initialLang: any,
  initialCountryCode: any,
  isBot: boolean
) {
  let ret: any = {
    initialTitle: TITLE_TAG_DEFAULT_ENGLISH,
    ogTitle: OG_TITLE_DEFAULT_ENGLISH,
    metaDescription: META_DESCRIPTION_DEFAULT_ENGLISH,
    ogDescription: OG_DESCRIPTION_DEFAULT_ENGLISH,
    jsonLdSubscriptionCurrencyPrice: DEFAULT_SUBSCRIPTION_PRICE_USD,
    jsonLdCurrencyCaps: ISO_4217_CURRENCY_CODE_US_DOLLAR,
    jsonLdApplicationAbout: JSON_LD_APPLICATION_ABOUT_DEFAULT,
    jsonLdOrganizationDescription: JSON_LD_ORGANIZATION_DESCRIPTION_DEFAULT,
    ogUrl: OG_URL_HOME_ENGLISH,
    jsonLdSoftwareApplicationKeywords:
      JSON_LD_SOFTWARE_APPLICATION_KEYWORDS_ENGLISH,
    jsonLdOrganizationContactEmail: CONTACT_EMAIL,
    jsonLdHomeUrl: JSON_LD_URL_HOME_ENGLISH,
    metaKeywords: META_KEYWORDS_ENGLISH,
  }
  try {
    const jsonLdSoftwareApplicationKeywords: any = translate(
      JSON_LD_SOFTWARE_APPLICATION_KEYWORDS_ENGLISH,
      JSON_LD_SOFTWARE_APPLICATION_KEYWORDS_SPANISH,
      JSON_LD_SOFTWARE_APPLICATION_KEYWORDS_FRENCH,
      JSON_LD_SOFTWARE_APPLICATION_KEYWORDS_KOREAN,
      initialLang
    )
    const ogUrl: any =
      pageComponent == 'Home'
        ? translate(
            OG_URL_HOME_ENGLISH,
            OG_URL_HOME_SPANISH,
            OG_URL_HOME_FRENCH,
            OG_URL_HOME_KOREAN,
            initialLang
          )
        : pageComponent == 'Search'
        ? translate(
            OG_URL_SEARCH_ENGLISH,
            OG_URL_SEARCH_SPANISH,
            OG_URL_SEARCH_FRENCH,
            OG_URL_SEARCH_KOREAN,
            initialLang
          )
        : pageComponent == 'Contact'
        ? translate(
            OG_URL_CONTACT_ENGLISH,
            OG_URL_CONTACT_SPANISH,
            OG_URL_CONTACT_FRENCH,
            OG_URL_CONTACT_KOREAN,
            initialLang
          )
        : pageComponent == 'Playlists'
        ? translate(
            OG_URL_PLAYLIST_ENGLISH,
            OG_URL_PLAYLIST_SPANISH,
            OG_URL_PLAYLIST_FRENCH,
            OG_URL_PLAYLIST_KOREAN,
            initialLang
          )
        : pageComponent == 'Favorites'
        ? translate(
            OG_URL_FAVORITES_ENGLISH,
            OG_URL_FAVORITES_SPANISH,
            OG_URL_FAVORITES_FRENCH,
            OG_URL_FAVORITES_KOREAN,
            initialLang
          )
        : pageComponent == 'Settings'
        ? translate(
            OG_URL_SETTINGS_ENGLISH,
            OG_URL_SETTINGS_SPANISH,
            OG_URL_SETTINGS_FRENCH,
            OG_URL_SETTINGS_KOREAN,
            initialLang
          )
        : translate(
            OG_URL_HOME_ENGLISH,
            OG_URL_HOME_SPANISH,
            OG_URL_HOME_FRENCH,
            OG_URL_HOME_KOREAN,
            initialLang
          )
    const jsonLdApplicationAbout: any = translate(
      JSON_LD_APPLICATION_ABOUT_ENGLISH,
      JSON_LD_APPLICATION_ABOUT_SPANISH,
      JSON_LD_APPLICATION_ABOUT_FRENCH,
      JSON_LD_APPLICATION_ABOUT_KOREAN,
      initialLang
    )
    const jsonLdOrganizationDescription = translate(
      JSON_LD_ORGANIZATION_DESCRIPTION_ENGLISH,
      JSON_LD_ORGANIZATION_DESCRIPTION_SPANISH,
      JSON_LD_ORGANIZATION_DESCRIPTION_FRENCH,
      JSON_LD_ORGANIZATION_DESCRIPTION_KOREAN,
      initialLang
    )
    const initialTitle: any =
      pageComponent == 'Home'
        ? !isBot
          ? translate(
              TITLE_TAG_HOME_ENGLISH_USER,
              TITLE_TAG_HOME_SPANISH_USER,
              TITLE_TAG_HOME_FRENCH_USER,
              TITLE_TAG_HOME_KOREAN_USER,
              initialLang
            )
          : translate(
              TITLE_TAG_HOME_ENGLISH,
              TITLE_TAG_HOME_SPANISH,
              TITLE_TAG_HOME_FRENCH,
              TITLE_TAG_HOME_KOREAN,
              initialLang
            )
        : pageComponent == 'Search'
        ? translate(
            TITLE_TAG_SEARCH_ENGLISH,
            TITLE_TAG_SEARCH_SPANISH,
            TITLE_TAG_SEARCH_FRENCH,
            TITLE_TAG_SEARCH_KOREAN,
            initialLang
          )
        : pageComponent == 'Settings'
        ? translate(
            TITLE_TAG_SETTINGS_ENGLISH,
            TITLE_TAG_SETTINGS_SPANISH,
            TITLE_TAG_SETTINGS_FRENCH,
            TITLE_TAG_SETTINGS_KOREAN,
            initialLang
          )
        : pageComponent == 'Contact'
        ? !isBot
          ? translate(
              TITLE_TAG_CONTACT_ENGLISH,
              TITLE_TAG_CONTACT_SPANISH,
              TITLE_TAG_CONTACT_FRENCH,
              TITLE_TAG_CONTACT_KOREAN,
              initialLang
            )
          : translate(
              TITLE_TAG_CONTACT_ENGLISH,
              TITLE_TAG_CONTACT_SPANISH,
              TITLE_TAG_CONTACT_FRENCH,
              TITLE_TAG_CONTACT_KOREAN,
              initialLang
            )
        : pageComponent == 'Favorites'
        ? !isBot
          ? translate(
              TITLE_TAG_FAVORITES_ENGLISH,
              TITLE_TAG_FAVORITES_SPANISH,
              TITLE_TAG_FAVORITES_FRENCH,
              TITLE_TAG_FAVORITES_KOREAN,
              initialLang
            )
          : translate(
              TITLE_TAG_FAVORITES_ENGLISH,
              TITLE_TAG_FAVORITES_SPANISH,
              TITLE_TAG_FAVORITES_FRENCH,
              TITLE_TAG_FAVORITES_KOREAN,
              initialLang
            )
        : pageComponent == 'Playlists'
        ? !isBot
          ? translate(
              TITLE_TAG_PLAYLISTS_ENGLISH,
              TITLE_TAG_PLAYLISTS_SPANISH,
              TITLE_TAG_PLAYLISTS_FRENCH,
              TITLE_TAG_PLAYLISTS_KOREAN,
              initialLang
            )
          : translate(
              TITLE_TAG_PLAYLISTS_ENGLISH,
              TITLE_TAG_PLAYLISTS_SPANISH,
              TITLE_TAG_PLAYLISTS_FRENCH,
              TITLE_TAG_PLAYLISTS_KOREAN,
              initialLang
            )
        : translate(
            TITLE_TAG_HOME_ENGLISH,
            TITLE_TAG_HOME_SPANISH,
            TITLE_TAG_HOME_FRENCH,
            TITLE_TAG_HOME_KOREAN,
            initialLang
          )
    const ogTitle: any =
      pageComponent == 'Home'
        ? OG_TITLE_DEFAULT_ENGLISH
        : pageComponent == 'Settings'
        ? translate(
            OG_TITLE_SETTINGS_ENGLISH,
            OG_TITLE_SETTINGS_SPANISH,
            OG_TITLE_SETTINGS_FRENCH,
            OG_TITLE_SETTINGS_KOREAN,
            initialLang
          )
        : pageComponent == 'Playlists'
        ? translate(
            OG_TITLE_PLAYLISTS_ENGLISH,
            OG_TITLE_PLAYLISTS_SPANISH,
            OG_TITLE_PLAYLISTS_FRENCH,
            OG_TITLE_PLAYLISTS_KOREAN,
            initialLang
          )
        : pageComponent == 'Favorites'
        ? translate(
            OG_TITLE_FAVORITES_ENGLISH,
            OG_TITLE_FAVORITES_SPANISH,
            OG_TITLE_FAVORITES_FRENCH,
            OG_TITLE_FAVORITES_KOREAN,
            initialLang
          )
        : pageComponent == 'Contact'
        ? translate(
            OG_TITLE_CONTACT_ENGLISH,
            OG_TITLE_CONTACT_SPANISH,
            OG_TITLE_CONTACT_FRENCH,
            OG_TITLE_CONTACT_KOREAN,
            initialLang
          )
        : pageComponent == 'Search'
        ? translate(
            OG_TITLE_SEARCH_ENGLISH,
            OG_TITLE_SEARCH_SPANISH,
            OG_TITLE_SEARCH_FRENCH,
            OG_TITLE_SEARCH_KOREAN,
            initialLang
          )
        : OG_TITLE_DEFAULT_ENGLISH
    const metaDescription: any =
      pageComponent == 'Home'
        ? translate(
            META_DESCRIPTION_HOME_ENGLISH,
            META_DESCRIPTION_HOME_SPANISH,
            META_DESCRIPTION_HOME_FRENCH,
            META_DESCRIPTION_HOME_KOREAN,
            initialLang
          )
        : pageComponent == 'Search'
        ? translate(
            META_DESCRIPTION_SEARCH_ENGLISH,
            META_DESCRIPTION_SEARCH_SPANISH,
            META_DESCRIPTION_SEARCH_FRENCH,
            META_DESCRIPTION_SEARCH_KOREAN,
            initialLang
          )
        : pageComponent == 'Contact'
        ? translate(
            META_DESCRIPTION_CONTACT_ENGLISH,
            META_DESCRIPTION_CONTACT_SPANISH,
            META_DESCRIPTION_CONTACT_FRENCH,
            META_DESCRIPTION_CONTACT_KOREAN,
            initialLang
          )
        : pageComponent == 'Playlists'
        ? translate(
            META_DESCRIPTION_PLAYLISTS_ENGLISH,
            META_DESCRIPTION_PLAYLISTS_SPANISH,
            META_DESCRIPTION_PLAYLISTS_FRENCH,
            META_DESCRIPTION_PLAYLISTS_KOREAN,
            initialLang
          )
        : pageComponent == 'Favorites'
        ? translate(
            META_DESCRIPTION_FAVORITES_ENGLISH,
            META_DESCRIPTION_FAVORITES_SPANISH,
            META_DESCRIPTION_FAVORITES_FRENCH,
            META_DESCRIPTION_FAVORITES_KOREAN,
            initialLang
          )
        : pageComponent == 'Settings'
        ? translate(
            META_DESCRIPTION_SETTINGS_ENGLISH,
            META_DESCRIPTION_SETTINGS_SPANISH,
            META_DESCRIPTION_SETTINGS_FRENCH,
            META_DESCRIPTION_SETTINGS_KOREAN,
            initialLang
          )
        : translate(
            META_DESCRIPTION_HOME_ENGLISH,
            META_DESCRIPTION_HOME_SPANISH,
            META_DESCRIPTION_HOME_FRENCH,
            META_DESCRIPTION_HOME_KOREAN,
            initialLang
          )
    const ogDescription: any =
      pageComponent == 'Home'
        ? translate(
            OG_DESCRIPTION_HOME_ENGLISH,
            OG_DESCRIPTION_HOME_SPANISH,
            OG_DESCRIPTION_HOME_FRENCH,
            OG_DESCRIPTION_HOME_KOREAN,
            initialLang
          )
        : pageComponent == 'Search'
        ? translate(
            OG_DESCRIPTION_SEARCH_ENGLISH,
            OG_DESCRIPTION_SEARCH_SPANISH,
            OG_DESCRIPTION_SEARCH_FRENCH,
            OG_DESCRIPTION_SEARCH_KOREAN,
            initialLang
          )
        : pageComponent == 'Contact'
        ? translate(
            OG_DESCRIPTION_CONTACT_ENGLISH,
            OG_DESCRIPTION_CONTACT_SPANISH,
            OG_DESCRIPTION_CONTACT_FRENCH,
            OG_DESCRIPTION_CONTACT_KOREAN,
            initialLang
          )
        : pageComponent == 'Playlists'
        ? translate(
            OG_DESCRIPTION_PLAYLISTS_ENGLISH,
            OG_DESCRIPTION_PLAYLISTS_SPANISH,
            OG_DESCRIPTION_PLAYLISTS_FRENCH,
            OG_DESCRIPTION_PLAYLISTS_KOREAN,
            initialLang
          )
        : pageComponent == 'Favorites'
        ? translate(
            OG_DESCRIPTION_FAVORITES_ENGLISH,
            OG_DESCRIPTION_FAVORITES_SPANISH,
            OG_DESCRIPTION_FAVORITES_FRENCH,
            OG_DESCRIPTION_FAVORITES_KOREAN,
            initialLang
          )
        : pageComponent == 'Settings'
        ? translate(
            OG_DESCRIPTION_SETTINGS_ENGLISH,
            OG_DESCRIPTION_SETTINGS_SPANISH,
            OG_DESCRIPTION_SETTINGS_FRENCH,
            OG_DESCRIPTION_SETTINGS_KOREAN,
            initialLang
          )
        : translate(
            OG_DESCRIPTION_HOME_ENGLISH,
            OG_DESCRIPTION_HOME_SPANISH,
            OG_DESCRIPTION_HOME_FRENCH,
            OG_DESCRIPTION_HOME_KOREAN,
            initialLang
          )
    const countryCodeCaps: string = isNotNullOrEmptyString(initialCountryCode)
      ? toTrimmedStringUpperCase(initialCountryCode)
      : ''
    const isEuro: boolean =
      EURO_CURRENCY_ISO_3166_ALPHA_2_COUNTRY_CODES?.length > 0 &&
      EURO_CURRENCY_ISO_3166_ALPHA_2_COUNTRY_CODES?.some(
        (ec: any) => ec == countryCodeCaps
      )
    const isBritain: boolean =
      BRITAIN_ISO_3166_ALPHA_2_CODE == countryCodeCaps ||
      BRITAIN_ISO_3166_ALPHA_2_CODE_ALT == countryCodeCaps
    const isCanada: boolean = CANADA_ISO_3166_ALPHA_2_CODE == countryCodeCaps
    const isKorea: boolean =
      SOUTH_KOREA_ISO_3166_ALPHA_2_CODE == countryCodeCaps
    const jsonLdSubscriptionCurrencyPrice: string = isEuro
      ? DEFAULT_SUBSCRIPTION_PRICE_EURO
      : isCanada
      ? DEFAULT_SUBSCRIPTION_PRICE_CAD
      : isBritain
      ? DEFAULT_SUBSCRIPTION_PRICE_POUND
      : DEFAULT_SUBSCRIPTION_PRICE_USD
    const jsonLdCurrencyCaps: string = isEuro
      ? ISO_4217_CURRENCY_CODE_EURO
      : isCanada
      ? ISO_4217_CURRENCY_CODE_CANADA_DOLLAR
      : isBritain
      ? ISO_4217_CURRENCY_CODE_BRITISH_POUND
      : ISO_4217_CURRENCY_CODE_US_DOLLAR
    const jsonLdOrganizationContactEmail: any = translate(
      CONTACT_EMAIL,
      CONTACT_EMAIL_ES,
      CONTACT_EMAIL_FR,
      CONTACT_EMAIL_ES,
      initialLang
    )
    const jsonLdHomeUrl: string = translate(
      JSON_LD_URL_HOME_ENGLISH,
      JSON_LD_URL_HOME_SPANISH,
      JSON_LD_URL_HOME_FRENCH,
      JSON_LD_URL_HOME_KOREAN,
      initialLang
    )
    const metaKeywords: string =
      pageComponent == 'Playlists'
        ? translate(
            META_KEYWORDS_PLAYLIST_ENGLISH,
            META_KEYWORDS_PLAYLIST_FRENCH,
            META_KEYWORDS_PLAYLIST_SPANISH,
            META_KEYWORDS_PLAYLIST_KOREAN,
            initialLang
          )
        : pageComponent == 'Favorites'
        ? translate(
            META_KEYWORDS_FAVORITES_ENGLISH,
            META_KEYWORDS_FAVORITES_SPANISH,
            META_KEYWORDS_FAVORITES_FRENCH,
            META_KEYWORDS_FAVORITES_KOREAN,
            initialLang
          )
        : pageComponent == 'Contact'
        ? translate(
            META_KEYWORDS_CONTACT_ENGLISH,
            META_KEYWORDS_CONTACT_SPANISH,
            META_KEYWORDS_CONTACT_FRENCH,
            META_KEYWORDS_CONTACT_KOREAN,
            initialLang
          )
        : translate(
            META_KEYWORDS_ENGLISH,
            META_KEYWORDS_SPANISH,
            META_KEYWORDS_FRENCH,
            META_KEYWORDS_KOREAN,
            initialLang
          )
    ret = {
      initialTitle: initialTitle,
      ogTitle: ogTitle,
      metaDescription: metaDescription,
      ogDescription: ogDescription,
      jsonLdSubscriptionCurrencyPrice: jsonLdSubscriptionCurrencyPrice,
      jsonLdSubscriptionCurrencyPriceValidUntil:
        getSubscriptionPriceValidUntil(),
      jsonLdCurrencyCaps: jsonLdCurrencyCaps,
      jsonLdApplicationAbout: jsonLdApplicationAbout,
      jsonLdApplicationAboutName: PRODUCT_NAME,
      jsonLdOrganizationDescription: jsonLdOrganizationDescription,
      ogUrl: ogUrl,
      jsonLdSoftwareApplicationKeywords: jsonLdSoftwareApplicationKeywords,
      jsonLdOrganizationContactEmail: jsonLdOrganizationContactEmail,
      jsonLdHomeUrl: jsonLdHomeUrl,
      metaKeywords: metaKeywords,
    }
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}
